import { setupPrefetchData } from '~vueutil/vue.js'
import { reactive } from 'vue'
import { defineStore } from 'pinia'
import { useRpcapi } from '~vueutil/pinia.js'
import { setupAuth } from '~vueutil/auth.js'

const name = 'auth'
export const useAuthStore = defineStore(name, () => {
  const rpcapi = useRpcapi()

  const state = reactive({
    id: '',
    expire: 0
  })

  async function fetchData () {
    const authState = await rpcapi.getAuthState()
    if (!authState) {
      return state
    }

    const { id, expire, picture, sex } = authState
    return Object.assign(state, {
      id,
      expire,
      picture,
      sex
    })
  }

  setupAuth(state)
  return setupPrefetchData({
    fetchData,

    getState () {
      return state
    },
    state
  })
})

export async function signOut () {
  const rpcapi = useRpcapi()
  return await rpcapi.signOut()
}
